import * as React from "react";
import { forwardRef } from "react";
const SvgBubble = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 28, height: 19, viewBox: "0 0 28 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.4712 17.4704C13.2702 18.4164 14.7282 18.4164 15.5272 17.4704L27.503 3.29047C28.6011 1.99028 27.6769 0 25.975 0H2.02337C0.321519 0 -0.602689 1.99028 0.495404 3.29047L12.4712 17.4704Z", fill: "white" }));
const ForwardRef = forwardRef(SvgBubble);
export { ForwardRef as ReactComponent };
